"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _lodash = require("lodash");
var _root_model = _interopRequireDefault(require("./root_model"));
var _word = _interopRequireDefault(require("./word"));
var _level = _interopRequireDefault(require("./level"));
var _image = _interopRequireDefault(require("./image"));
var _page = _interopRequireDefault(require("./page"));
var _video_clip = _interopRequireDefault(require("./video_clip"));
var _word_type_basic = _interopRequireDefault(require("./word_type_basic"));
var _concept_category = _interopRequireDefault(require("./concept_category"));
var _intersecting_concept = _interopRequireDefault(require("./intersecting_concept"));
var _spacy_attribute = _interopRequireDefault(require("./spacy_attribute"));
var _sentence = _interopRequireDefault(require("./sentence"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Concept = (_dec = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_word["default"]))), _dec2 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_word["default"]))), _dec3 = (0, _serializr.serializable)((0, _serializr.object)(_video_clip["default"])), _dec4 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_intersecting_concept["default"]))), _dec5 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_intersecting_concept["default"]))), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_image["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_page["default"])), _dec8 = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec9 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_sentence["default"]))), _dec0 = (0, _serializr.serializable)((0, _serializr.object)(_word_type_basic["default"])), _dec1 = (0, _serializr.serializable)((0, _serializr.object)(_concept_category["default"])), _dec10 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_spacy_attribute["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function Concept() {
    var _this;
    _classCallCheck(this, Concept);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Concept, [].concat(args));
    // there is also a concept_basic.js
    _initializerDefineProperty(_this, "name", _descriptor, _this);
    _initializerDefineProperty(_this, "id", _descriptor2, _this);
    _initializerDefineProperty(_this, "rating", _descriptor3, _this);
    _initializerDefineProperty(_this, "normalizedName", _descriptor4, _this);
    _initializerDefineProperty(_this, "sentencesCount", _descriptor5, _this);
    _initializerDefineProperty(_this, "wordsCount", _descriptor6, _this);
    _initializerDefineProperty(_this, "rootWordsCount", _descriptor7, _this);
    _initializerDefineProperty(_this, "shortDescription", _descriptor8, _this);
    _initializerDefineProperty(_this, "longDescriptionMd", _descriptor9, _this);
    _initializerDefineProperty(_this, "longDescription", _descriptor0, _this);
    _initializerDefineProperty(_this, "vocab", _descriptor1, _this);
    _initializerDefineProperty(_this, "validSetup", _descriptor10, _this);
    _initializerDefineProperty(_this, "lesson", _descriptor11, _this);
    _initializerDefineProperty(_this, "abbreviation", _descriptor12, _this);
    _initializerDefineProperty(_this, "joinType", _descriptor13, _this);
    _initializerDefineProperty(_this, "automaticAssociations", _descriptor14, _this);
    _initializerDefineProperty(_this, "wordTypeId", _descriptor15, _this);
    _initializerDefineProperty(_this, "published", _descriptor16, _this);
    _initializerDefineProperty(_this, "featured", _descriptor17, _this);
    _initializerDefineProperty(_this, "pinned", _descriptor18, _this);
    _initializerDefineProperty(_this, "grammarCase", _descriptor19, _this);
    _initializerDefineProperty(_this, "grammarTense", _descriptor20, _this);
    _initializerDefineProperty(_this, "highlightInEdit", _descriptor21, _this);
    _initializerDefineProperty(_this, "levelId", _descriptor22, _this);
    _initializerDefineProperty(_this, "score", _descriptor23, _this);
    _initializerDefineProperty(_this, "showAsConcept", _descriptor24, _this);
    _initializerDefineProperty(_this, "infinitive", _descriptor25, _this);
    _initializerDefineProperty(_this, "showAsInfinitive", _descriptor26, _this);
    _initializerDefineProperty(_this, "showNameWithSource", _descriptor27, _this);
    _initializerDefineProperty(_this, "sentencesMaintainOrdering", _descriptor28, _this);
    _initializerDefineProperty(_this, "intersectingWordTypeId", _descriptor29, _this);
    _initializerDefineProperty(_this, "forumThreadId", _descriptor30, _this);
    _initializerDefineProperty(_this, "gender", _descriptor31, _this);
    _initializerDefineProperty(_this, "regex", _descriptor32, _this);
    _initializerDefineProperty(_this, "plural", _descriptor33, _this);
    _initializerDefineProperty(_this, "deckIds", _descriptor34, _this);
    _initializerDefineProperty(_this, "decksCount", _descriptor35, _this);
    _initializerDefineProperty(_this, "treeNodeConceptsCount", _descriptor36, _this);
    _initializerDefineProperty(_this, "decksAverageCompleted", _descriptor37, _this);
    _initializerDefineProperty(_this, "totalCardsCount", _descriptor38, _this);
    _initializerDefineProperty(_this, "seenCardsCount", _descriptor39, _this);
    _initializerDefineProperty(_this, "useConceptCategoryDescription", _descriptor40, _this);
    _initializerDefineProperty(_this, "showAsWordType", _descriptor41, _this);
    _initializerDefineProperty(_this, "icon", _descriptor42, _this);
    _initializerDefineProperty(_this, "conceptCategoryId", _descriptor43, _this);
    _initializerDefineProperty(_this, "displayNameLine1", _descriptor44, _this);
    _initializerDefineProperty(_this, "displayNameLine2", _descriptor45, _this);
    _initializerDefineProperty(_this, "includeConjugations", _descriptor46, _this);
    _initializerDefineProperty(_this, "showOnGenderCard", _descriptor47, _this);
    _initializerDefineProperty(_this, "showOnPluralCard", _descriptor48, _this);
    _initializerDefineProperty(_this, "showInDictionary", _descriptor49, _this);
    _initializerDefineProperty(_this, "pluralRegex", _descriptor50, _this);
    _initializerDefineProperty(_this, "spacyTense", _descriptor51, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor52, _this);
    _initializerDefineProperty(_this, "vocabTriadDeckId", _descriptor53, _this);
    _initializerDefineProperty(_this, "hasAllSupplements", _descriptor54, _this);
    _initializerDefineProperty(_this, "hasAllVideoClips", _descriptor55, _this);
    _initializerDefineProperty(_this, "displaySentences", _descriptor56, _this);
    _initializerDefineProperty(_this, "commentsCount", _descriptor57, _this);
    _initializerDefineProperty(_this, "grammarNodeId", _descriptor58, _this);
    _initializerDefineProperty(_this, "grammarDescriptionId", _descriptor59, _this);
    _initializerDefineProperty(_this, "grammarDescriptionLanguageId", _descriptor60, _this);
    _initializerDefineProperty(_this, "youtubeUrl", _descriptor61, _this);
    _initializerDefineProperty(_this, "groupId", _descriptor62, _this);
    _initializerDefineProperty(_this, "words", _descriptor63, _this);
    _initializerDefineProperty(_this, "intersectingWords", _descriptor64, _this);
    _initializerDefineProperty(_this, "videoClip", _descriptor65, _this);
    _initializerDefineProperty(_this, "intersectingConcepts", _descriptor66, _this);
    _initializerDefineProperty(_this, "unionConcepts", _descriptor67, _this);
    _initializerDefineProperty(_this, "image", _descriptor68, _this);
    _initializerDefineProperty(_this, "page", _descriptor69, _this);
    _initializerDefineProperty(_this, "level", _descriptor70, _this);
    _initializerDefineProperty(_this, "sentences", _descriptor71, _this);
    _initializerDefineProperty(_this, "wordType", _descriptor72, _this);
    _initializerDefineProperty(_this, "conceptCategory", _descriptor73, _this);
    _initializerDefineProperty(_this, "spacyAttributes", _descriptor74, _this);
    return _this;
  }
  _inherits(Concept, _RootModel);
  return _createClass(Concept, [{
    key: "displayNameLine1WithCase",
    get: function get() {
      if ((0, _utils.isPresent)(this.displayNameLine1) && this.languageId === 'DE') {
        return (0, _lodash.compact)([this.displayNameLine1, this.caseName]).join(', ');
      } else if ((0, _utils.isPresent)(this.displayNameLine1)) {
        return this.displayNameLine1;
      }
      return this.name;
    }
  }, {
    key: "caseName",
    get: function get() {
      var _this2 = this;
      var myCase = _constants.Constants.CASES.find(function (item) {
        return item.abbreviation === _this2.grammarCase;
      });
      if (myCase && myCase.name === 'None' && this.languageId === 'DE') {
        return 'No Case';
      }
      if (myCase) {
        return "".concat(myCase.name, " Case");
      }
      return null;
    }
  }, {
    key: "requiresCase",
    get: function get() {
      return this.hasWordType && this.wordType.requiresCase;
    }
  }, {
    key: "noun",
    get: function get() {
      return this.hasWordType && this.wordType.abbreviation === 'noun';
    }
  }, {
    key: "verb",
    get: function get() {
      return this.hasWordType && this.wordType.abbreviation === 'vrb';
    }
  }, {
    key: "isDative",
    get: function get() {
      return this.grammarCase === 'Dt' || this.grammarCase === '2w-Dt';
    }
  }, {
    key: "isAccusative",
    get: function get() {
      return this.grammarCase === 'Ak' || this.grammarCase === '2w-Ak';
    }
  }, {
    key: "isNominative",
    get: function get() {
      return this.grammarCase === 'Nm';
    }
  }, {
    key: "isGenitive",
    get: function get() {
      return this.grammarCase === 'Gn';
    }
  }, {
    key: "imageUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.image) ? this.image.url : null;
    }
  }, {
    key: "levelAbbreviation",
    get: function get() {
      return (0, _utils.isPresent)(this.level) ? this.level.abbreviation : null;
    }
  }, {
    key: "intersectingWordIds",
    get: function get() {
      return (0, _utils.isPresent)(this.intersectingWords) ? this.intersectingWords.map(function (item) {
        return item.id;
      }) : {};
    }
  }, {
    key: "intersectingConceptIds",
    get: function get() {
      return (0, _utils.isPresent)(this.intersectingConcepts) ? this.intersectingConcepts.map(function (item) {
        return item.id;
      }) : {};
    }
  }, {
    key: "unionConceptIds",
    get: function get() {
      return (0, _utils.isPresent)(this.unionConcepts) ? this.unionConcepts.map(function (item) {
        return item.id;
      }) : {};
    }
  }, {
    key: "hasVideoClip",
    get: function get() {
      return (0, _utils.isPresent)(this.videoClip);
    }
  }, {
    key: "hasWordType",
    get: function get() {
      return (0, _utils.isPresent)(this.wordType) && (0, _utils.isPresent)(this.wordType.id);
    }
  }, {
    key: "mappedIntersectingWords",
    get: function get() {
      return this.intersectingWords.map(function (item) {
        return {
          id: item.id,
          name: item.targetWithWordTypeParentInfinitiveAndSource
        };
      });
    }
  }, {
    key: "mappedIntersectingConcepts",
    get: function get() {
      return this.intersectingConcepts.map(function (item) {
        return {
          id: item.id,
          name: item.name
        };
      });
    }
  }, {
    key: "mappedUnionConcepts",
    get: function get() {
      return this.unionConcepts.map(function (item) {
        return {
          id: item.id,
          name: item.name
        };
      });
    }
  }, {
    key: "nameAndLevel",
    get: function get() {
      return "".concat(this.name, " (").concat(this.levelAbbreviation, ")");
    }
  }, {
    key: "nameAndLevelAndSentencesCount",
    get: function get() {
      return "".concat(this.nameAndLevel, " - ").concat(this.sentencesCount, " sentences");
    }
  }, {
    key: "nameAndLevelAndSentencesAndDecksCount",
    get: function get() {
      return "".concat(this.nameAndLevel, " - ").concat(this.decksCount, " decks - ").concat(this.sentencesCount, " sentences");
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "id", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "rating", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "normalizedName", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sentencesCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "wordsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "rootWordsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "shortDescription", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "longDescriptionMd", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "longDescription", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "vocab", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "validSetup", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "lesson", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "abbreviation", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "joinType", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "automaticAssociations", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "wordTypeId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "published", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "featured", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "pinned", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "grammarCase", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "grammarTense", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "highlightInEdit", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "levelId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "score", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "showAsConcept", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "infinitive", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "showAsInfinitive", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "showNameWithSource", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "sentencesMaintainOrdering", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "intersectingWordTypeId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "forumThreadId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "gender", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "regex", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "plural", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "deckIds", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "decksCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "treeNodeConceptsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "decksAverageCompleted", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "totalCardsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "seenCardsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "useConceptCategoryDescription", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "showAsWordType", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "icon", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "conceptCategoryId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "displayNameLine1", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "displayNameLine2", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "includeConjugations", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "showOnGenderCard", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "showOnPluralCard", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "showInDictionary", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "pluralRegex", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "spacyTense", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "vocabTriadDeckId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "hasAllSupplements", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "hasAllVideoClips", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "displaySentences", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "commentsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "grammarNodeId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "grammarDescriptionId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "grammarDescriptionLanguageId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "youtubeUrl", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "groupId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "words", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "intersectingWords", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "videoClip", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "intersectingConcepts", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "unionConcepts", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "image", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "page", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "level", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "sentences", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "wordType", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "conceptCategory", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "spacyAttributes", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _class);
var _default = exports["default"] = Concept;